module.exports = __webpack_public_path__ + "img/BronzeNewRecord.6b8163af.gif";